import React from 'react'
import gifweb3 from '../assets/imgs/shopifygif.gif'

export const GifwebThree = () => {
  return (
    <div>
        <img src={gifweb3} alt="gifweb" className="w-full h-full m-3 rounded-md" />
    </div>
  )
}